export async function execute(args, context) {
  const { fileList } = context;

  if (!fileList || fileList.length === 0) {
    return {
      success: false,
      error: 'No files in project'
    };
  }

  const files = fileList.map(f => ({
    path: f.Key,
    size: f.Size
  }));

  return {
    success: true,
    files,
    summary: `Found ${files.length} files`
  };
}
